var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainPageSectionMobileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 844,
    viewBox: "0 0 390 844",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_3199)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    fill: "url(#paint0_linear_2460_3199)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.24 206.091C409.573 206.091 455.24 160.424 455.24 104.091C455.24 47.7578 409.573 2.09082 353.24 2.09082C296.907 2.09082 251.24 47.7578 251.24 104.091C251.24 160.424 296.907 206.091 353.24 206.091Z",
    stroke: "#7D0633",
    strokeWidth: 0.478803,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.24 172.443C390.99 172.443 421.592 141.841 421.592 104.091C421.592 66.3414 390.99 35.7393 353.24 35.7393C315.491 35.7393 284.889 66.3414 284.889 104.091C284.889 141.841 315.491 172.443 353.24 172.443Z",
    stroke: "#7D0633",
    strokeWidth: 0.478803,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.239 138.791C372.404 138.791 387.94 123.256 387.94 104.091C387.94 84.9265 372.404 69.3906 353.239 69.3906C334.075 69.3906 318.539 84.9265 318.539 104.091C318.539 123.256 334.075 138.791 353.239 138.791Z",
    stroke: "#7D0633",
    strokeWidth: 0.478803,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2460_3199)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2460_3199)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 353.157,
    cy: 105.71,
    r: 15.9601,
    fill: "#5F0527"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2460_3199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.144 108.392C345.144 109.165 345.314 109.755 345.536 110.114C345.655 110.318 345.825 110.487 346.03 110.604C346.235 110.721 346.468 110.782 346.704 110.781C347.275 110.781 347.797 110.64 348.804 109.252C349.61 108.139 350.56 106.582 351.2 105.598L352.283 103.939C353.035 102.788 353.904 101.508 354.904 100.637C355.718 99.9315 356.597 99.538 357.481 99.538C358.966 99.538 360.381 100.396 361.463 102.005C362.648 103.767 363.226 105.987 363.226 108.278C363.226 109.64 362.956 110.64 362.498 111.431C362.056 112.195 361.191 112.959 359.739 112.959V110.781C360.982 110.781 361.29 109.642 361.29 108.34C361.29 106.483 360.856 104.423 359.899 102.951C359.221 101.907 358.341 101.269 357.373 101.269C356.327 101.269 355.484 102.056 354.538 103.459C354.034 104.204 353.518 105.113 352.938 106.138L352.299 107.262C351.016 109.53 350.691 110.046 350.05 110.899C348.928 112.397 347.968 112.959 346.704 112.959C345.205 112.959 344.257 112.312 343.673 111.336C343.19 110.542 342.955 109.499 342.955 108.311L345.144 108.392Z",
    fill: "#CF0A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.682 102.159C345.685 100.616 347.134 99.5379 348.795 99.5379C349.757 99.5379 350.714 99.819 351.712 100.635C352.805 101.524 353.968 102.987 355.422 105.4L355.943 106.265C357.2 108.354 357.916 109.427 358.334 109.935C358.873 110.585 359.251 110.778 359.74 110.778C360.982 110.778 361.29 109.639 361.29 108.337L363.222 108.276C363.222 109.638 362.952 110.639 362.494 111.429C362.057 112.195 361.191 112.959 359.74 112.959C358.838 112.959 358.038 112.764 357.154 111.932C356.475 111.294 355.681 110.161 355.07 109.142L353.252 106.115C352.34 104.596 351.503 103.463 351.019 102.953C350.497 102.398 349.828 101.732 348.76 101.732C347.895 101.732 347.161 102.337 346.546 103.263L344.682 102.159Z",
    fill: "#CF0A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.759 101.732C347.895 101.732 347.16 102.337 346.546 103.263C345.676 104.57 345.144 106.518 345.144 108.392C345.144 109.165 345.314 109.755 345.536 110.114L343.67 111.336C343.19 110.542 342.955 109.499 342.955 108.311C342.955 106.15 343.55 103.898 344.681 102.159C345.685 100.617 347.133 99.538 348.795 99.538L348.759 101.732Z",
    fill: "#CF0A54"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M363.343 1.91521C363.343 2.84074 362.593 3.59102 361.667 3.59102C360.742 3.59102 359.991 2.84074 359.991 1.91521C359.991 0.989688 360.742 0.239402 361.667 0.239402C362.593 0.239402 363.343 0.989688 363.343 1.91521Z",
    fill: "url(#paint1_radial_2460_3199)",
    stroke: "#7D0633",
    strokeWidth: 0.478803
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.564 197.693C313.564 198.618 312.814 199.368 311.888 199.368C310.963 199.368 310.212 198.618 310.212 197.693C310.212 196.767 310.963 196.017 311.888 196.017C312.814 196.017 313.564 196.767 313.564 197.693Z",
    fill: "url(#paint2_radial_2460_3199)",
    stroke: "#7D0633",
    strokeWidth: 0.478803
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.734 103.901C286.734 104.826 285.983 105.576 285.058 105.576C284.132 105.576 283.382 104.826 283.382 103.901C283.382 102.975 284.132 102.225 285.058 102.225C285.983 102.225 286.734 102.975 286.734 103.901Z",
    fill: "url(#paint3_radial_2460_3199)",
    stroke: "#7D0633",
    strokeWidth: 0.478803
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.355 75.172C374.355 76.0975 373.604 76.8478 372.679 76.8478C371.753 76.8478 371.003 76.0975 371.003 75.172C371.003 74.2465 371.753 73.4962 372.679 73.4962C373.604 73.4962 374.355 74.2465 374.355 75.172Z",
    fill: "url(#paint4_radial_2460_3199)",
    stroke: "#7D0633",
    strokeWidth: 0.478803
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 206.091C93.333 206.091 139 160.424 139 104.091C139 47.7578 93.333 2.09084 37 2.09084C-19.333 2.09084 -65 47.7578 -65 104.091C-65 160.424 -19.333 206.091 37 206.091Z",
    stroke: "#7D0633",
    strokeWidth: 0.478803,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0002 172.443C74.7499 172.443 105.352 141.841 105.352 104.091C105.352 66.3414 74.7499 35.7393 37.0002 35.7393C-0.749422 35.7393 -31.3516 66.3414 -31.3516 104.091C-31.3516 141.841 -0.749422 172.443 37.0002 172.443Z",
    stroke: "#7D0633",
    strokeWidth: 0.478803,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9992 138.791C56.1637 138.791 71.6996 123.256 71.6996 104.091C71.6996 84.9265 56.1637 69.3906 36.9992 69.3906C17.8347 69.3906 2.29883 84.9265 2.29883 104.091C2.29883 123.256 17.8347 138.791 36.9992 138.791Z",
    stroke: "#7D0633",
    strokeWidth: 0.478803,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2460_3199)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2460_3199)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.921,
    cy: 105.71,
    r: 15.9601,
    fill: "#5F0527"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2460_3199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1778 99.6631C34.3446 99.2252 34.574 98.8222 34.9145 98.4955C36.2766 97.1681 38.5283 97.5017 39.4526 99.1696C40.1476 100.434 40.8842 101.672 41.6001 102.922C42.7954 105 44.0046 107.078 45.1861 109.163C46.1799 110.908 45.1027 113.111 43.129 113.409C41.9197 113.59 40.7869 113.034 40.1615 111.95C39.1121 110.122 38.0557 108.295 37.0063 106.474C36.9855 106.432 36.9577 106.397 36.9299 106.363C36.8187 106.272 36.77 106.14 36.7005 106.022C36.2349 105.202 35.7554 104.389 35.2898 103.576C34.9909 103.048 34.6782 102.526 34.3794 101.998C34.1083 101.526 33.9832 101.011 33.9971 100.469C34.018 100.191 34.0527 99.9132 34.1778 99.6631Z",
    fill: "#CF0A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1775 99.6631C34.1149 99.9133 34.0593 100.163 34.0454 100.428C34.0246 101.011 34.1705 101.553 34.4624 102.061C35.2269 103.374 35.9913 104.695 36.7489 106.015C36.8184 106.133 36.874 106.251 36.9435 106.363C36.5265 107.085 36.1095 107.801 35.6856 108.524C35.1018 109.532 34.518 110.546 33.9273 111.554C33.8995 111.554 33.8926 111.54 33.8856 111.519C33.8787 111.464 33.8995 111.415 33.9134 111.359C34.1983 110.317 33.9621 109.393 33.2462 108.6C32.8084 108.121 32.2524 107.85 31.6131 107.759C30.7791 107.641 30.0424 107.857 29.3822 108.378C29.2641 108.468 29.1876 108.6 29.0486 108.67C29.0208 108.67 29.0069 108.656 29 108.635C29.3336 108.058 29.6602 107.481 29.9938 106.905C31.3698 104.514 32.7459 102.123 34.1288 99.7395C34.1427 99.7117 34.1636 99.6909 34.1775 99.6631Z",
    fill: "#A10841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0273 108.656C29.1593 108.538 29.2844 108.413 29.4234 108.302C31.1122 106.968 33.6488 107.934 34.0171 110.046C34.1075 110.554 34.0588 111.04 33.906 111.526C33.899 111.568 33.8921 111.603 33.8782 111.645C33.8156 111.756 33.76 111.874 33.6905 111.985C33.072 113.007 32.1616 113.514 30.9663 113.438C29.5972 113.34 28.52 112.312 28.3323 110.95C28.242 110.289 28.374 109.671 28.7146 109.101C28.7841 108.976 28.8675 108.865 28.9439 108.74C28.9786 108.712 28.9648 108.656 29.0273 108.656Z",
    fill: "#CF0A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0267 108.657C28.9989 108.685 28.9989 108.733 28.9503 108.74C28.9433 108.691 28.9711 108.664 28.9989 108.629L29.0267 108.657Z",
    fill: "#FABC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8787 111.645C33.8509 111.596 33.8787 111.561 33.9065 111.526C33.9135 111.533 33.9273 111.547 33.9343 111.554L33.8787 111.645Z",
    fill: "#E1C025"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M47.1027 1.91521C47.1027 2.84074 46.3525 3.59102 45.4269 3.59102C44.5014 3.59102 43.7511 2.84074 43.7511 1.91521C43.7511 0.989688 44.5014 0.239402 45.4269 0.239402C46.3525 0.239402 47.1027 0.989688 47.1027 1.91521Z",
    fill: "url(#paint5_radial_2460_3199)",
    stroke: "#7D0633",
    strokeWidth: 0.478803
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.954 103.901C106.954 104.826 106.204 105.576 105.278 105.576C104.353 105.576 103.603 104.826 103.603 103.901C103.603 102.975 104.353 102.225 105.278 102.225C106.204 102.225 106.954 102.975 106.954 103.901Z",
    fill: "url(#paint6_radial_2460_3199)",
    stroke: "#7D0633",
    strokeWidth: 0.478803
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1164 75.1719C58.1164 76.0975 57.3661 76.8477 56.4406 76.8477C55.5151 76.8477 54.7648 76.0975 54.7648 75.1719C54.7648 74.2464 55.5151 73.4961 56.4406 73.4961C57.3661 73.4961 58.1164 74.2464 58.1164 75.1719Z",
    fill: "url(#paint7_radial_2460_3199)",
    stroke: "#7D0633",
    strokeWidth: 0.478803
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4199 419C72.557 419 99.4199 392.137 99.4199 359C99.4199 325.863 72.557 299 39.4199 299C6.28284 299 -20.5801 325.863 -20.5801 359C-20.5801 392.137 6.28284 419 39.4199 419Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9215 402.019C63.1862 402.019 82.046 383.159 82.046 359.894C82.046 336.629 63.1862 317.77 39.9215 317.77C16.6567 317.77 -2.20312 336.629 -2.20312 359.894C-2.20312 383.159 16.6567 402.019 39.9215 402.019Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9208 381.28C51.7317 381.28 61.3064 371.705 61.3064 359.894C61.3064 348.084 51.7317 338.509 39.9208 338.509C28.1099 338.509 18.5353 348.084 18.5353 359.894C18.5353 371.705 28.1099 381.28 39.9208 381.28Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2460_3199)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.0977,
    cy: 359.812,
    r: 9.83607,
    fill: "#5F0527"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2460_3199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6888 356.574C43.6813 356.52 43.634 356.49 43.5948 356.486C43.5558 356.483 42.7288 356.422 42.7288 356.422C42.7288 356.422 42.1544 355.852 42.0914 355.788C42.0283 355.725 41.9052 355.745 41.8573 355.759C41.8503 355.761 41.7319 355.797 41.5359 355.858C41.3441 355.306 41.0055 354.798 40.4098 354.798C40.3934 354.798 40.3764 354.799 40.3595 354.8C40.1901 354.576 39.9802 354.479 39.799 354.479C38.4114 354.479 37.7485 356.213 37.5406 357.095C37.0014 357.262 36.6184 357.381 36.5695 357.396C36.2685 357.49 36.259 357.5 36.2194 357.784C36.1897 357.998 35.4022 364.088 35.4022 364.088L41.5385 365.238L44.8633 364.519C44.8633 364.519 43.6961 356.628 43.6888 356.574ZM41.1968 355.963L40.6776 356.123C40.6777 356.087 40.6779 356.051 40.6779 356.012C40.6779 355.668 40.6303 355.392 40.5539 355.173C40.8608 355.212 41.0652 355.561 41.1968 355.963ZM40.1731 355.241C40.2585 355.455 40.314 355.762 40.314 356.176C40.314 356.197 40.3138 356.216 40.3136 356.236C39.9759 356.341 39.609 356.454 39.2412 356.568C39.4477 355.771 39.8348 355.386 40.1731 355.241ZM39.7609 354.851C39.8208 354.851 39.8811 354.871 39.9388 354.911C39.4941 355.12 39.0175 355.647 38.8162 356.7L37.9685 356.962C38.2043 356.16 38.7642 354.851 39.7609 354.851Z",
    fill: "#CF0A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5952 356.486C43.5562 356.483 42.7292 356.421 42.7292 356.421C42.7292 356.421 42.1549 355.851 42.0918 355.788C42.0682 355.764 42.0364 355.752 42.0032 355.747L41.5392 365.237L44.8637 364.518C44.8637 364.518 43.6965 356.627 43.6892 356.573C43.6818 356.519 43.6344 356.489 43.5952 356.486Z",
    fill: "#A10841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4117 358.323L40.0017 359.542C40.0017 359.542 39.6425 359.351 39.2023 359.351C38.5568 359.351 38.5243 359.756 38.5243 359.858C38.5243 360.415 39.9761 360.628 39.9761 361.933C39.9761 362.959 39.3251 363.62 38.4474 363.62C37.394 363.62 36.8553 362.965 36.8553 362.965L37.1374 362.033C37.1374 362.033 37.6911 362.508 38.1583 362.508C38.4636 362.508 38.5878 362.268 38.5878 362.092C38.5878 361.366 37.3967 361.333 37.3967 360.139C37.3967 359.135 38.1179 358.162 39.5737 358.162C40.1346 358.162 40.4117 358.323 40.4117 358.323Z",
    fill: "#5F0527"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1081,
    cy: 400.902,
    rx: 1.18033,
    ry: 1.18033,
    fill: "#E30B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1408 400.902C83.1408 401.472 82.6785 401.935 82.1081 401.935C81.5377 401.935 81.0753 401.472 81.0753 400.902C81.0753 400.332 81.5377 399.869 82.1081 399.869C82.6785 399.869 83.1408 400.332 83.1408 400.902Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.8034,
    cy: 317.876,
    rx: 1.18033,
    ry: 1.18033,
    fill: "#E30B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8362 317.876C40.8362 318.446 40.3738 318.908 39.8034 318.908C39.233 318.908 38.7706 318.446 38.7706 317.876C38.7706 317.305 39.233 316.843 39.8034 316.843C40.3738 316.843 40.8362 317.305 40.8362 317.876Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.272125,
    cy: 373.755,
    rx: 1.18033,
    ry: 1.18033,
    fill: "#E30B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.30491 373.755C1.30491 374.325 0.842518 374.787 0.272125 374.787C-0.298268 374.787 -0.760662 374.325 -0.760662 373.755C-0.760662 373.184 -0.298268 372.722 0.272125 372.722C0.842518 372.722 1.30491 373.184 1.30491 373.755Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.7975,
    cy: 381.229,
    rx: 1.18033,
    ry: 1.18033,
    fill: "#E30B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8303 381.229C41.8303 381.8 41.3679 382.262 40.7975 382.262C40.2271 382.262 39.7647 381.8 39.7647 381.229C39.7647 380.659 40.2271 380.196 40.7975 380.196C41.3679 380.196 41.8303 380.659 41.8303 381.229Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.42 419C383.557 419 410.42 392.137 410.42 359C410.42 325.863 383.557 299 350.42 299C317.283 299 290.42 325.863 290.42 359C290.42 392.137 317.283 419 350.42 419Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.921 402.019C374.186 402.019 393.046 383.159 393.046 359.894C393.046 336.629 374.186 317.77 350.921 317.77C327.657 317.77 308.797 336.629 308.797 359.894C308.797 383.159 327.657 402.019 350.921 402.019Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.921 381.28C362.732 381.28 372.306 371.705 372.306 359.894C372.306 348.084 362.732 338.509 350.921 338.509C339.11 338.509 329.535 348.084 329.535 359.894C329.535 371.705 339.11 381.28 350.921 381.28Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2460_3199)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 351.098,
    cy: 359.812,
    r: 9.83607,
    fill: "#5F0527"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2460_3199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.689 356.574C354.681 356.52 354.634 356.49 354.595 356.486C354.556 356.483 353.729 356.422 353.729 356.422C353.729 356.422 353.154 355.852 353.091 355.788C353.028 355.725 352.905 355.745 352.857 355.759C352.85 355.761 352.732 355.797 352.536 355.858C352.344 355.306 352.005 354.798 351.41 354.798C351.393 354.798 351.376 354.799 351.36 354.8C351.19 354.576 350.98 354.479 350.799 354.479C349.411 354.479 348.748 356.213 348.541 357.095C348.001 357.262 347.618 357.381 347.569 357.396C347.268 357.49 347.259 357.5 347.219 357.784C347.19 357.998 346.402 364.088 346.402 364.088L352.538 365.238L355.863 364.519C355.863 364.519 354.696 356.628 354.689 356.574ZM352.197 355.963L351.678 356.123C351.678 356.087 351.678 356.051 351.678 356.012C351.678 355.668 351.63 355.392 351.554 355.173C351.861 355.212 352.065 355.561 352.197 355.963ZM351.173 355.241C351.258 355.455 351.314 355.762 351.314 356.176C351.314 356.197 351.314 356.216 351.314 356.236C350.976 356.341 350.609 356.454 350.241 356.568C350.448 355.771 350.835 355.386 351.173 355.241ZM350.761 354.851C350.821 354.851 350.881 354.871 350.939 354.911C350.494 355.12 350.017 355.647 349.816 356.7L348.969 356.962C349.204 356.16 349.764 354.851 350.761 354.851Z",
    fill: "#CF0A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.595 356.486C354.556 356.483 353.729 356.421 353.729 356.421C353.729 356.421 353.155 355.851 353.092 355.788C353.068 355.764 353.036 355.752 353.003 355.747L352.539 365.237L355.864 364.518C355.864 364.518 354.697 356.627 354.689 356.573C354.682 356.519 354.634 356.489 354.595 356.486Z",
    fill: "#A10841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.412 358.323L351.002 359.542C351.002 359.542 350.643 359.351 350.202 359.351C349.557 359.351 349.524 359.756 349.524 359.858C349.524 360.415 350.976 360.628 350.976 361.933C350.976 362.959 350.325 363.62 349.447 363.62C348.394 363.62 347.855 362.965 347.855 362.965L348.137 362.033C348.137 362.033 348.691 362.508 349.158 362.508C349.464 362.508 349.588 362.268 349.588 362.092C349.588 361.366 348.397 361.333 348.397 360.139C348.397 359.135 349.118 358.162 350.574 358.162C351.135 358.162 351.412 358.323 351.412 358.323Z",
    fill: "#5F0527"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 350.803,
    cy: 317.876,
    rx: 1.18033,
    ry: 1.18033,
    fill: "#E30B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.836 317.876C351.836 318.446 351.374 318.908 350.803 318.908C350.233 318.908 349.771 318.446 349.771 317.876C349.771 317.305 350.233 316.843 350.803 316.843C351.374 316.843 351.836 317.305 351.836 317.876Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.272,
    cy: 373.755,
    rx: 1.18033,
    ry: 1.18033,
    fill: "#E30B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.305 373.755C312.305 374.325 311.843 374.787 311.272 374.787C310.702 374.787 310.239 374.325 310.239 373.755C310.239 373.184 310.702 372.722 311.272 372.722C311.843 372.722 312.305 373.184 312.305 373.755Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 351.798,
    cy: 381.229,
    rx: 1.18033,
    ry: 1.18033,
    fill: "#E30B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.83 381.229C352.83 381.8 352.368 382.262 351.798 382.262C351.227 382.262 350.765 381.8 350.765 381.229C350.765 380.659 351.227 380.196 351.798 380.196C352.368 380.196 352.83 380.659 352.83 381.229Z",
    stroke: "#7D0633",
    strokeOpacity: 0.8,
    strokeWidth: 0.295082
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2460_3199",
    x: 329.536,
    y: 82.089,
    width: 47.4684,
    height: 47.5067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.83043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2460_3199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2460_3199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2460_3199",
    x: 329.536,
    y: 82.089,
    width: 47.2419,
    height: 47.2419,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.83043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2460_3199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2460_3199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2460_3199",
    x: 13.3001,
    y: 82.0892,
    width: 47.4665,
    height: 47.5066,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.83043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2460_3199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2460_3199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2460_3199",
    x: 13.3001,
    y: 82.0892,
    width: 47.2419,
    height: 47.2419,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.83043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2460_3199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2460_3199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2460_3199",
    x: 25.5403,
    y: 345.254,
    width: 29.1147,
    height: 29.1148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.36066
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2460_3199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2460_3199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2460_3199",
    x: 336.54,
    y: 345.254,
    width: 29.1147,
    height: 29.1148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.36066
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2460_3199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2460_3199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_3199",
    x1: 195,
    y1: 0,
    x2: 195,
    y2: 844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30B5C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2460_3199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(361.667 1.91521) rotate(48.5913) scale(4.00794 3.69887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.501022,
    stopColor: "#E30B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2460_3199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(311.888 197.693) rotate(48.5913) scale(4.00794 3.69887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.501022,
    stopColor: "#E30B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2460_3199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.058 103.901) rotate(48.5913) scale(4.00794 3.69887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.501022,
    stopColor: "#E30B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2460_3199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(372.679 75.172) rotate(48.5913) scale(4.00794 3.69887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.501022,
    stopColor: "#E30B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2460_3199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.4269 1.91521) rotate(48.5913) scale(4.00794 3.69887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.501022,
    stopColor: "#E30B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2460_3199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.278 103.901) rotate(48.5913) scale(4.00794 3.69887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.501022,
    stopColor: "#E30B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2460_3199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4406 75.1719) rotate(48.5913) scale(4.00794 3.69887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.501022,
    stopColor: "#E30B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_3199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2460_3199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2683,
    height: 13.421,
    fill: "white",
    transform: "translate(342.955 99.538)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2460_3199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4436,
    height: 15.7757,
    fill: "white",
    transform: "translate(28.207 97.6758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2460_3199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8149,
    height: 10.8149,
    fill: "white",
    transform: "translate(34.7362 354.449)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2460_3199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8149,
    height: 10.8149,
    fill: "white",
    transform: "translate(345.736 354.449)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainPageSectionMobileBg);
export default __webpack_public_path__ + "static/media/mainPageSectionMobileBG.2d6429e77b57a55b1e468f17aefa1c76.svg";
export { ForwardRef as ReactComponent };